export const topicsData = [
  { id: 1, name: "搞笑综艺", heat: "238万讨论", icon: "ri-emotion-laugh-line", color: "bg-primary-500" },
  { id: 2, name: "真人秀", heat: "196万讨论", icon: "ri-user-star-line", color: "bg-accent-500" },
  { id: 3, name: "脱口秀", heat: "172万讨论", icon: "ri-mic-line", color: "bg-secondary-500" },
  { id: 4, name: "选秀综艺", heat: "158万讨论", icon: "ri-trophy-line", color: "bg-primary-400" },
  { id: 5, name: "旅行综艺", heat: "134万讨论", icon: "ri-flight-takeoff-line", color: "bg-accent-400" },
  { id: 6, name: "音乐综艺", heat: "121万讨论", icon: "ri-music-line", color: "bg-secondary-400" },
  { id: 7, name: "推理综艺", heat: "108万讨论", icon: "ri-lightbulb-line", color: "bg-primary-300" },
  { id: 8, name: "恋爱综艺", heat: "95万讨论", icon: "ri-heart-line", color: "bg-accent-300" },
  { id: 9, name: "美食综艺", heat: "82万讨论", icon: "ri-restaurant-line", color: "bg-secondary-300" },
  { id: 10, name: "竞技综艺", heat: "76万讨论", icon: "ri-speed-mini-line", color: "bg-primary-200" },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-movie-line",
    title: "海量综艺资源",
    description: "收录国内外热门综艺数千部，涵盖搞笑、真人秀、脱口秀、音乐、旅行等全品类，每日更新热门综艺超过50期，综艺大全尽在红桃影院。",
  },
  {
    id: 2,
    icon: "ri-hd-line",
    title: "高清流畅体验",
    description: "全站综艺高清在线看，支持1080P超清画质，智能CDN加速技术确保播放流畅不缓冲，多线路自动切换保证观看不卡顿。",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "多端同步观看",
    description: "支持手机、平板、电脑多终端同步，随时随地免费看最新综艺，播放记录云端同步，换设备也能无缝续播。",
  },
  {
    id: 4,
    icon: "ri-thumb-up-line",
    title: "免费无广告干扰",
    description: "全站综艺免费观看，无需会员即可畅享高清资源，极简广告策略确保观看体验清爽，每日欢乐不被打断。",
  },
];

export const rankingData = [
  { rank: 1, title: "欢乐喜剧人·第十季", heat: "本周热度 2,385万", trend: "up", tag: "搞笑综艺" },
  { rank: 2, title: "奔跑吧·特别季", heat: "本周热度 2,103万", trend: "up", tag: "真人秀" },
  { rank: 3, title: "脱口秀大会·第六季", heat: "本周热度 1,867万", trend: "up", tag: "脱口秀" },
  { rank: 4, title: "这！就是街舞·第七季", heat: "本周热度 1,542万", trend: "down", tag: "竞技综艺" },
  { rank: 5, title: "密室大逃脱·第五季", heat: "本周热度 1,328万", trend: "up", tag: "推理综艺" },
  { rank: 6, title: "中餐厅·第八季", heat: "本周热度 1,196万", trend: "stable", tag: "美食综艺" },
  { rank: 7, title: "心动的信号·第七季", heat: "本周热度 987万", trend: "up", tag: "恋爱综艺" },
];

export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%20and%20bright%20eyes%2C%20soft%20peach%20background%2C%20illustration%20style%2C%20clean%20and%20friendly%20portrait&width=80&height=80&seq=avatar-01&orientation=squarish",
    nickname: "欢乐小鱼儿",
    date: "2026年7月30日",
    content: "红桃影院的综艺资源真的太全了！我追了好几档搞笑综艺都在这里有高清资源和更新提醒，画质清晰流畅，每天追综艺太快乐了～",
    likes: 1283,
    show: "欢乐喜剧人",
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20young%20Chinese%20man%20with%20gentle%20smile%2C%20soft%20warm%20tone%20background%2C%20illustration%20style%2C%20clean%20portrait&width=80&height=80&seq=avatar-02&orientation=squarish",
    nickname: "综艺控阿杰",
    date: "2026年7月29日",
    content: "作为一个综艺迷，这个站真的是我见过最用心的娱乐综艺平台。真人秀免费看而且更新超快，比某些视频网站还及时，已经推荐给身边所有朋友了！",
    likes: 967,
    show: "奔跑吧",
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20young%20Chinese%20girl%20with%20happy%20expression%2C%20soft%20pink%20background%2C%20illustration%20style%2C%20warm%20portrait&width=80&height=80&seq=avatar-03&orientation=squarish",
    nickname: "夏日柠檬茶",
    date: "2026年7月28日",
    content: "搞笑综艺一网打尽太方便了！以前要找各种平台才能看完喜欢的节目，现在在红桃一站搞定。还有综艺大全分类和热榜功能，找片超方便！",
    likes: 756,
    show: "脱口秀大会",
  },
];

export const updatesData = [
  { id: 1, date: "07-31", title: "《欢乐喜剧人·第十季》第8期更新上线", tag: "最新上线" },
  { id: 2, date: "07-30", title: "《奔跑吧·特别季》云南特辑完整版发布", tag: "热门更新" },
  { id: 3, date: "07-29", title: "《脱口秀大会·第六季》半决赛精彩对决", tag: "热门更新" },
  { id: 4, date: "07-28", title: "综艺大全分类页全新改版上线", tag: "平台动态" },
  { id: 5, date: "07-27", title: "《密室大逃脱·第五季》古堡谜案篇播出", tag: "最新上线" },
  { id: 6, date: "07-26", title: "《中餐厅·第八季》成都站圆满收官", tag: "季终回顾" },
  { id: 7, date: "07-25", title: "4K超清画质技术升级全面完成", tag: "平台动态" },
  { id: 8, date: "07-24", title: "《这！就是街舞·第七季》战队PK赛开启", tag: "热门更新" },
  { id: 9, date: "07-23", title: "《心动的信号·第七季》新嘉宾入驻引热议", tag: "最新上线" },
];

export const faqData = [
  {
    id: 1,
    question: "红桃影院的综艺资源需要付费吗？",
    answer: "不需要！红桃影院所有热门综艺、真人秀均可免费观看，我们致力于为观众提供免费综艺高清在线看服务，无需会员即可畅享海量内容，每日欢乐不停。",
  },
  {
    id: 2,
    question: "综艺在线观看的画质和缓冲情况怎么样？",
    answer: "全站综艺高清在线看，普遍支持720P和1080P超清画质。我们采用智能CDN加速和多线路切换技术，确保播放流畅不缓冲，为您带来最佳观看体验。",
  },
  {
    id: 3,
    question: "最新综艺一般多久能在红桃影院看到？",
    answer: "热门综艺通常播出后24小时内完成更新上线。我们拥有专业的综艺大全内容团队，持续跟踪各大卫视和平台的综艺动态，力争让大家在第一时间免费看到最新综艺。",
  },
  {
    id: 4,
    question: "综艺在线观看支持哪些设备？需要下载App吗？",
    answer: "支持电脑、平板和手机浏览器直接访问，无需下载任何应用。我们提供响应式网页设计，在任何设备上都能获得流畅的综艺在线观看体验，自动适配屏幕尺寸。",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "欢乐喜剧人·爆笑名场面集锦",
    thumbnail: "https://readdy.ai/api/search-image?query=Comedy%20variety%20show%20stage%20with%20bright%20stage%20lights%20and%20comedians%20performing%2C%20warm%20golden%20tones%2C%20entertainment%20show%20atmosphere%2C%20audience%20laughing%2C%20professional%20stage%20photography%2C%20vibrant%20colors&width=640&height=360&seq=media-01&orientation=landscape",
    duration: "12:38",
    views: "182万",
    tag: "搞笑综艺",
  },
  {
    id: 2,
    title: "奔跑吧·云南站幕后花絮特辑",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20reality%20show%20filming%20in%20Yunnan%20beautiful%20nature%20landscape%2C%20celebrities%20doing%20fun%20challenges%2C%20bright%20sunny%20day%2C%20vibrant%20green%20mountains%2C%20entertainment%20photography%2C%20warm%20lighting&width=640&height=360&seq=media-02&orientation=landscape",
    duration: "08:15",
    views: "156万",
    tag: "真人秀",
  },
  {
    id: 3,
    title: "脱口秀大会·半决赛巅峰对决",
    thumbnail: "https://readdy.ai/api/search-image?query=Stand%20up%20comedy%20stage%20with%20spotlight%20on%20microphone%2C%20warm%20stage%20atmosphere%2C%20professional%20lighting%2C%20entertainment%20venue%2C%20dark%20background%20with%20dramatic%20lighting%2C%20comedy%20show%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape",
    duration: "15:42",
    views: "203万",
    tag: "脱口秀",
  },
  {
    id: 4,
    title: "密室大逃脱·古堡终极解密",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20castle%20interior%20with%20dim%20dramatic%20lighting%2C%20escape%20room%20game%20show%20set%2C%20ancient%20furniture%20and%20candles%2C%20mystery%20atmosphere%2C%20cinematic%20photography%2C%20warm%20golden%20candlelight&width=640&height=360&seq=media-04&orientation=landscape",
    duration: "18:20",
    views: "145万",
    tag: "推理综艺",
  },
];

export const carouselData = [
  {
    id: 1,
    title: "欢乐喜剧人·第十季",
    subtitle: "笑料不断，欢乐升级",
    description: "国内顶级搞笑综艺全新一季回归，喜剧大咖云集，爆笑段子密集轰炸，每周五晚准时更新，让你笑到停不下来！",
    image: "https://readdy.ai/api/search-image?query=Comedy%20stage%20show%20with%20bright%20colorful%20lights%20and%20comedians%20in%20spotlight%2C%20red%20curtain%20background%2C%20entertainment%20variety%20show%20aesthetic%2C%20warm%20golden%20stage%20lighting%2C%20festive%20atmosphere%2C%20professional%20theater%20photography&width=1200&height=700&seq=carousel-01&orientation=landscape",
    tag: "搞笑综艺",
    badge: "热播中",
  },
  {
    id: 2,
    title: "奔跑吧·特别季",
    subtitle: "云南特辑，欢乐出发",
    description: "跑男团集结云南，在大美风光中展开爆笑挑战，真人秀免费看尽在红桃影院，每周六更新高清完整版。",
    image: "https://readdy.ai/api/search-image?query=Group%20of%20celebrities%20running%20outdoors%20in%20beautiful%20Yunnan%20mountain%20landscape%2C%20bright%20sunshine%2C%20green%20rice%20terraces%2C%20reality%20show%20photography%2C%20vibrant%20colors%2C%20energetic%20atmosphere&width=1200&height=700&seq=carousel-02&orientation=landscape",
    tag: "真人秀",
    badge: "热播中",
  },
  {
    id: 3,
    title: "脱口秀大会·第六季",
    subtitle: "半决赛激战正酣",
    description: "脱口秀大会第六季迎来半决赛，选手金句频出引爆全场，搞笑综艺人气王之争进入白热化阶段！",
    image: "https://readdy.ai/api/search-image?query=Stand%20up%20comedy%20stage%20with%20single%20microphone%20under%20dramatic%20spotlight%2C%20red%20theater%20curtain%2C%20warm%20stage%20atmosphere%2C%20professional%20entertainment%20photography%2C%20dark%20background%20with%20golden%20light&width=1200&height=700&seq=carousel-03&orientation=landscape",
    tag: "脱口秀",
    badge: "热播中",
  },
  {
    id: 4,
    title: "密室大逃脱·第五季",
    subtitle: "古堡谜案，烧脑升级",
    description: "推理综艺天花板回归，明星团队勇闯神秘古堡，层层解密惊险刺激，每周四更新高清在线看。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20castle%20interior%20with%20mysterious%20atmosphere%2C%20candlelit%20room%20with%20old%20furniture%2C%20escape%20game%20aesthetic%2C%20warm%20dim%20lighting%2C%20cinematic%20photography%2C%20dramatic%20shadows%20on%20stone%20walls&width=1200&height=700&seq=carousel-04&orientation=landscape",
    tag: "推理综艺",
    badge: "热播中",
  },
  {
    id: 5,
    title: "中餐厅·第八季",
    subtitle: "成都美食之旅",
    description: "中餐厅成都站圆满收官，明星大厨烹制地道川味，美食综艺精彩回顾尽在红桃影院综艺在线观看。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20restaurant%20kitchen%20with%20chefs%20cooking%20Sichuan%20cuisine%2C%20steaming%20hot%20dishes%20on%20table%2C%20warm%20lighting%2C%20busy%20kitchen%20atmosphere%2C%20delicious%20food%20photography%2C%20golden%20ambient%20light&width=1200&height=700&seq=carousel-05&orientation=landscape",
    tag: "美食综艺",
    badge: "季终回顾",
  },
];

export const cardsData = [
  {
    id: 1,
    title: "《这就是街舞》第七季",
    description: "街舞选秀综艺重磅回归，全球顶尖舞者齐聚，用舞蹈燃炸舞台，每周六更新高清在线看。",
    image: "https://readdy.ai/api/search-image?query=Street%20dance%20competition%20stage%20with%20dancer%20under%20colorful%20stage%20lights%2C%20urban%20dance%20aesthetic%2C%20dynamic%20movement%2C%20warm%20spotlight%2C%20entertainment%20photography%2C%20energetic%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape",
    tag: "竞技综艺",
    update: "更新至第8期",
  },
  {
    id: 2,
    title: "《心动的信号》第七季",
    description: "恋爱综艺甜蜜回归，新一季素人嘉宾颜值在线，心动信号一触即发，每周三更新完整版。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20dating%20show%20scene%20with%20soft%20pink%20and%20warm%20lighting%2C%20elegant%20living%20room%20interior%2C%20flowers%20and%20candles%2C%20reality%20dating%20show%20aesthetic%2C%20cozy%20atmosphere%2C%20gentle%20golden%20hour%20light&width=600&height=400&seq=card-02&orientation=landscape",
    tag: "恋爱综艺",
    update: "更新至第6期",
  },
  {
    id: 3,
    title: "《向往的生活》第九季",
    description: "慢综艺经典之作，回归田园感受生活本真，明星嘉宾的治愈日常，每周五更新高清在线看。",
    image: "https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20courtyard%20with%20wooden%20house%20and%20green%20fields%2C%20warm%20sunset%20light%2C%20slow%20living%20aesthetic%2C%20rustic%20charm%2C%20nature%20photography%2C%20golden%20hour%20glow&width=600&height=400&seq=card-03&orientation=landscape",
    tag: "旅行综艺",
    update: "更新至第10期",
  },
  {
    id: 4,
    title: "《这！就是灌篮》第六季",
    description: "篮球竞技综艺燃爆夏日，全国高校篮球队巅峰对决，热血青春激燃赛场，每周日更新。",
    image: "https://readdy.ai/api/search-image?query=Basketball%20court%20with%20players%20in%20action%20under%20bright%20arena%20lights%2C%20sports%20competition%2C%20dynamic%20movement%2C%20warm%20indoor%20lighting%2C%20sports%20photography%2C%20energetic%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape",
    tag: "竞技综艺",
    update: "更新至第5期",
  },
  {
    id: 5,
    title: "《乐队的夏天》第四季",
    description: "音乐综艺回归，全国顶尖乐队同台竞技，用音乐点燃整个夏天，每周六晚更新高清完整版。",
    image: "https://readdy.ai/api/search-image?query=Rock%20band%20performing%20on%20stage%20with%20colorful%20concert%20lights%2C%20musicians%20with%20instruments%2C%20live%20music%20atmosphere%2C%20warm%20stage%20lighting%2C%20concert%20photography%2C%20energetic%20crowd&width=600&height=400&seq=card-05&orientation=landscape",
    tag: "音乐综艺",
    update: "更新至第7期",
  },
  {
    id: 6,
    title: "《青春环游记》第六季",
    description: "旅行综艺新一季出发，明星嘉宾结伴环游中国，爆笑旅程美景不断，每周四更新高清在线看。",
    image: "https://readdy.ai/api/search-image?query=Group%20of%20friends%20traveling%20in%20beautiful%20Chinese%20landscape%20with%20mountains%20and%20lakes%2C%20bright%20sunny%20day%2C%20travel%20photography%2C%20warm%20golden%20light%2C%20happy%20vibe%2C%20scenic%20nature&width=600&height=400&seq=card-06&orientation=landscape",
    tag: "旅行综艺",
    update: "更新至第9期",
  },
];

export const indexData = [
  { id: 1, title: "搞笑综艺", icon: "ri-emotion-laugh-line", count: "86部", desc: "欢乐喜剧人、脱口秀大会等经典搞笑综艺合集" },
  { id: 2, title: "真人秀", icon: "ri-user-star-line", count: "64部", desc: "奔跑吧、向往的生活等热门真人秀免费看" },
  { id: 3, title: "脱口秀", icon: "ri-mic-line", count: "38部", desc: "国内最全脱口秀综艺在线观看平台" },
  { id: 4, title: "音乐综艺", icon: "ri-music-line", count: "52部", desc: "乐队的夏天、歌手等音乐综艺合集" },
  { id: 5, title: "推理综艺", icon: "ri-lightbulb-line", count: "29部", desc: "密室大逃脱、明星大侦探等烧脑之作" },
  { id: 6, title: "恋爱综艺", icon: "ri-heart-line", count: "33部", desc: "心动的信号、我们恋爱吧等甜蜜综艺" },
  { id: 7, title: "美食综艺", icon: "ri-restaurant-line", count: "41部", desc: "中餐厅、向往的生活等美食主题综艺" },
  { id: 8, title: "竞技综艺", icon: "ri-trophy-line", count: "47部", desc: "这就是街舞、这！就是灌篮等竞技热血综艺" },
];